/**
 * Messages module translations - Statuses section
 */

const statuses = {
  approved: "Approved",
  notAccepted: "Not Accepted",
  inReview: "In Review",
  voided: "Voided",
  pending: "Pending",
  noStatus: "No status",
};

export default statuses;
